<template>
  <main :class="pageData ? '' : 'loading'">
    <page-header
      :title="headerTitle"
      :image="headerImage"
      :content="headerContent">
    </page-header>
    <founder :bio="founderBio"></founder>
    <executive-advisory-board :board="executiveAdvisoryBoard"></executive-advisory-board>
    <chapter-boards :boards="chapterBoards"></chapter-boards>
    <mission-sponsors :sponsors="missionSponsors"></mission-sponsors>
    <corporate-sponsors :sponsors="corporateSponsors"></corporate-sponsors>
    <testimonials :testimonials="testimonials"></testimonials>
    <thank-you :thankYous="thankYous"></thank-you>
  </main>
</template>

<script>
import PageHeader from './layouts/PageHeader'
import Founder from './OurTeam/Founder'
import ExecutiveAdvisoryBoard from './OurTeam/ExecutiveAdvisoryBoard'
import ChapterBoards from './OurTeam/ChapterBoards'
import MissionSponsors from './OurTeam/MissionSponsors'
import CorporateSponsors from './OurTeam/CorporateSponsors'
import Testimonials from './OurTeam/Testimonials'
import ThankYou from './OurTeam/ThankYou'

export default {
  name: 'our-team',
  data () {
    return {
      headerTitle: 'Our Team',
      headerImage: 'PFK_OurTeam_Photo1_800x290.jpg',
      headerContent: '<ul><li><a href="#founder">Founder / CEO</a></li><li><a href="#executiveAdvisoryBoard">Executive Advisory Board</a></li><li><a href="#chapterBoards">Chapter Boards</a></li><li><a href="#missionSponsors">Mission Sponsors</a></li><li><a href="#corporateSponsors">Corporate Sponsors</a></li><li><a href="#testimonials">Testimonials</a></li><li><a href="#thankYou">Thank You</a></li></ul>',
      pageData: null
    }
  },
  computed: {
    founderBio () {
      if (this.acf) return this.acf.founder_bio
    },
    executiveAdvisoryBoard () {
      if (this.acf) return this.acf.executive_advisory_board
    },
    chapterBoards () {
      if (this.acf) return this.acf.chapter_boards
    },
    missionSponsors () {
      if (this.acf) return this.acf.mission_sponsors
    },
    corporateSponsors () {
      if (this.acf) return this.acf.corporate_sponsors
    },
    testimonials () {
      if (this.acf) return this.acf.testimonials
    },
    thankYous () {
      if (this.acf) return this.acf.thank_you
    },
    acf () {
      if (this.pageData && this.pageData.acf) return this.pageData.acf
    }
  },
  mounted () {
    this.getPageData()
  },
  methods: {
    getPageData () {
      const vm = this
      vm.$http.get('/pages?slug=our-team')
      .then((response) => {
        vm.pageData = response.data[0]
      })
    }
  },
  components: {
    PageHeader,
    Founder,
    ExecutiveAdvisoryBoard,
    ChapterBoards,
    MissionSponsors,
    CorporateSponsors,
    Testimonials,
    ThankYou
  }
}
</script>



// WEBPACK FOOTER //
// OurTeam.vue?040d43e4